import React from "react";
import SystemLabel from "../../../../../system/SystemLabel/SystemLabel";

import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Container,
  Row,
  Label,
  Col
} from "reactstrap";
import ConditionRow from "./ConditionRow";
import { conditionModel } from "../condition.model";
import { conditionConstants } from "../condition.constants";
import { securityHelper } from "../../../../../helpers/securityHelper";

class ConditionModal extends React.Component {
  state = {
    currentConditions: [],
    otherConditions: []
  };
  componentDidMount() {
    if (
      this.props.selectedElement &&
      this.props.selectedElement.data.conditions
    ) {
      let conditions = this.props.selectedElement.data.conditions;

      let filtered = conditions.filter(c => {
        return c.action === this.props.conditionAction;
      });
      if (!filtered) filtered = [];
      let other = conditions.filter(c => {
        return c.action !== this.props.conditionAction;
      });
      if (!other) other = [];
      this.setState({ currentConditions: filtered, otherConditions: other });
    }
  }
  componentDidUpdate(prevProps, prevState) { }

  addCondition = index => {
    let newCondition = Object.assign({}, conditionModel);
    let currentConditions = this.state.currentConditions;
    newCondition.operator = conditionConstants.operators.EQUAL;
    newCondition.sortNo = currentConditions.length + 1;
    newCondition.action = this.props.conditionAction;
    newCondition.id = securityHelper.createGuid();
    newCondition.prefix = currentConditions.length > 0 ? "AND" : "";
    newCondition.suffix = "";
    newCondition.indent = 0;
    if (index != undefined) {
      let cond = currentConditions[index];
      if (cond.suffix.includes(")")) {
        newCondition.suffix = cond.suffix;
        cond.suffix = cond.suffix = "";
        newCondition.indent = cond.indent;
        currentConditions = currentConditions
          .slice(0, index + 1)
          .concat(newCondition, currentConditions.slice(index + 1));
      } else {
        newCondition.indent = cond.indent;
        currentConditions = currentConditions
          .slice(0, index + 1)
          .concat(newCondition, currentConditions.slice(index + 1));
      }
    } else {
      currentConditions.push(newCondition);
    }
    this.setState({ currentConditions }, this.logConditions);
  };
  addConditionGroup = index => {
    let newCondition = Object.assign({}, conditionModel);
    let currentConditions = this.state.currentConditions;
    newCondition.operator = conditionConstants.operators.EQUAL;
    newCondition.sortNo = currentConditions.length + 1;
    newCondition.action = this.props.conditionAction;
    newCondition.id = securityHelper.createGuid();
    newCondition.prefix = currentConditions.length > 0 ? "AND(" : "(";
    newCondition.suffix = ")";
    newCondition.indent = 1;

    if (index != undefined) {
      let cond = currentConditions[index];
      if (cond.suffix.includes(")")) {
        newCondition.suffix = cond.suffix + ")";
        cond.suffix = cond.suffix = "";
        newCondition.indent = cond.indent + 1;
        currentConditions = currentConditions
          .slice(0, index + 1)
          .concat(newCondition, currentConditions.slice(index + 1));
      } else {
        newCondition.indent = cond.indent + 1;
        currentConditions = currentConditions
          .slice(0, index + 1)
          .concat(newCondition, currentConditions.slice(index + 1));
      }
    } else {
      currentConditions.push(newCondition);
    }
    this.setState({ currentConditions }, this.logConditions);
  };

  logConditions = () => {
    let str = "";
    this.state.currentConditions.map(c => {
      str += `${c.prefix} SRC ${c.operator} VAL ${c.suffix} \n`;
    });
  };
  updateCondition = (updatedCondition, index) => {
    let currentConditions = this.state.currentConditions;
    currentConditions[index] = updatedCondition;
    this.setState({ currentConditions });
  };
  removeCondition = index => {
    let currentConditions = Array.from(this.state.currentConditions);

    let removedCondition = currentConditions.splice(index, 1)[0];
    if (index > 0) {
      if (
        !removedCondition.prefix.includes("(") &&
        removedCondition.suffix.includes(")")
      ) {
        currentConditions[index - 1].suffix += removedCondition.suffix;
      }
      if (
        removedCondition.prefix.includes("(") &&
        !removedCondition.suffix.includes(")") &&
        currentConditions.length >= index + 1
      ) {
        currentConditions[index].prefix += "(";
      }
      if (
        removedCondition.prefix.includes("(") &&
        removedCondition.suffix.includes(")")
      ) {
        currentConditions[index - 1].suffix += removedCondition.suffix.substr(
          0,
          removedCondition.suffix.length - 1
        );
      }
    }
    this.setState({ currentConditions }, this.logConditions);
  };
  save = () => {
    let newConditions = Array.from(this.state.currentConditions).concat(this.state.otherConditions);
    this.props.update(newConditions/*  , this.props.selectedElement.formElementId */);
  };
  // toggle = () => {
  //     this.props.toggle();
  // }
  render() {
    const { sourceList } = this.props;
    return (
      <React.Fragment>
        <Modal
          isOpen={this.props.show}
          toggle={this.toggle}
          style={{ maxWidth: "60vw" }}
          className="condition-modal"
        >
          <ModalHeader toggle={this.props.toggle}>
            <SystemLabel name={this.props.conditionAction}></SystemLabel>
          </ModalHeader>
          <ModalBody>
            <Container>
              <Row style={{ margin: 0 }}>
                <Col md="3">
                  <Label className="text-muted">
                    <SystemLabel name="Source" />
                  </Label>
                </Col>
                <Col md="3">
                  <Label className="text-muted">
                    <SystemLabel name="Is" />
                  </Label>
                </Col>
                <Col md="4">
                  <Label className="text-muted">
                    <SystemLabel name="Value" />
                  </Label>
                </Col>
                <Col md="2">

                </Col>
              </Row>
              {this.state.currentConditions.length > 0
                ? this.state.currentConditions.map((c, i) => {
                  return (
                    <ConditionRow
                      index={i}
                      currentCondition={c}
                      update={this.updateCondition}
                      {...c}
                      sourceList={sourceList}
                      updateConditions={this.save}
                      key={i}
                      languageCode={this.props.languageCode}
                      removeCondition={this.removeCondition}
                      addCondition={this.addCondition}
                      addConditionGroup={this.addConditionGroup}
                    />
                  );
                })
                : null}
              <Row
                style={{
                  paddingTop: "3px",
                  margin: 0
                }}
              >
                <Col md="12">
                  <Button
                    style={{ backgroundColor: "#fff", marginRight: '2px' }}
                    className="condition-save-btn"
                    onClick={e => this.addCondition()}
                  >

                    <SystemLabel name="Add" />
                  </Button>
                  {" "}
                  <Button
                    style={{ backgroundColor: "#fff", }}
                    className="condition-save-btn"
                    onClick={e => this.addConditionGroup()}
                  >

                    <SystemLabel name="NewGroup" />
                  </Button>
                  {/*    </Col> */}
                  {/*     <Button onClick={e => this.addCondition()}>Add</Button> */}
                  {/*           <Button onClick={e => this.addConditionGroup()}>Group</Button> */}
                </Col>
              </Row>
            </Container>
          </ModalBody>
          <ModalFooter>
            <Button className="ignore-click" color="secondary" onClick={this.props.toggle}>
              <SystemLabel name="Cancel" />
            </Button>
            <Button className="ignore-click" color="success" onClick={this.save}>
              <SystemLabel name="Save" />
            </Button>{" "}
          </ModalFooter>
        </Modal>
      </React.Fragment >
    );
  }
}
export default ConditionModal;
